<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <!-- {{ selection }} -->
                        <b-tabs class="gridtabs" v-model="tabindex">
                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-check-square-o text-purple mr-1"></i>
                                        ATOLSALE
                                    </div>

                                </template>

                                <p class="mt-2">
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="success">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> To remove ATOLSALE transactions from the Conferma portal pick the dates in question. By default the query is based on BCARDCONF (you may change this). Click Go to perform the analysis.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>
                                    <b-row class="my-2">

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Issue Date" label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm"
                                                        ref="issued_at" v-model="issued_at" :opens="'right'"
                                                        :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true"
                                                        :linkedCalendars="true" :single-date-picker="false"
                                                        :disabled="false">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="true"
                                                            @click="issued_at = {
                                                                    startDate: null,
                                                                    endDate: null,
                                                                    }
                                                                        ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="blac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <b-button squared size="sm" variant="link" @click="saveit()" class="text-decoration-none">
                                                <i class="fa fa-play"></i>
                                             Go
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Analysis" label-for="notes" label-cols="12">
                                                <b-form-textarea id="notes" v-model="notes" placeholder="Analysis"
                                                    rows="10" class="smalltextarea"></b-form-textarea>
                                            </b-form-group></b-col></b-row>
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="success">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> If you wish to take the above out of the Conferma invoicing portal click Save It. This will set these transactions invoiceno to 'ATOLSALE' which will take them out of the invoicing portal.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>


                                </p>
                            </b-tab>
                        </b-tabs>

                    </b-card-body>
                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col class="text-left">
                                <!-- v-if="user.permissions.includes('inventorylines.save')" -->
                                <b-button squared size="sm" variant="primary" @click="saveit()">
                                    <i class="fa fa-check"></i>
                                    Save It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>

                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>

                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "AtolSale",
    async mounted() {
        await this.accessdenied();
        // this.ticketschange_load();
    },
    data() {
        return {
            busy: false,
            tabindex: 0,
            debounce: 500,
            readonly: false,
            issued_at: {
                startDate: this.$moment().startOf("month").format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            blac: "BCARDCONF",
            notes: null,
        };
    },
    watch: {},
    methods: {
        async accessdenied() {

        },
        async load() {
            this.referenceno = []

            for (var i = 0; i < this.selection.length; ++i) {
                this.referenceno.push(this.selection[i].referenceno)
            }

        },

        async saveit() {
            this.busy = true;

            let rows = []
            for (var i = 0; i < this.selection.length; ++i) {
                let row = {
                    id: this.selection[i].id
                }
                if (this.blac) {
                    row.blac = this.blac
                }
                if (this.notes) {
                    row.notes = this.notes
                }

                rows.push(row)
            }
            let variables = { rows }
            console.log(variables)

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                                mutation inventorylines_save($rows: [InventoryLine_input]) {
                                    inventorylines_save(rows: $rows) {
                                    id                                
                                    blac
                                  notes
                                }
                                }
                            `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },

    },
};
</script>